export const STEP_BY_PATH = {
  "/business-info": "business-info",
  "/payment-connect": "payment-connect",
  "/enrollment": "enrollment",
  "/alerts": "alerts",
  "/card-info": "card-info",
  "/top-up": "top-up",
  "/getting_started": "getting_started"
}
